<template>
  <div class="billing-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.billing.title') }}</h1>
        <p>{{ $t('bo.billing.subtitle') }}</p>
      </div>
    </div>

    <div class="tabs">
      <button
        :class="['tab-btn', { active: activeTab === 'wallets' }]"
        @click="activeTab = 'wallets'"
      >{{ $t('bo.billing.tabWallets') }}</button>
      <button
        :class="['tab-btn', { active: activeTab === 'purchases' }]"
        @click="activeTab = 'purchases'"
      >{{ $t('bo.billing.tabPurchases') }}</button>
    </div>

    <WalletsList v-if="activeTab === 'wallets'" />
    <PurchasesList v-if="activeTab === 'purchases'" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import WalletsList from './WalletsList.vue'
import PurchasesList from './PurchasesList.vue'

const activeTab = ref('wallets')
</script>

<style scoped>
.billing-manager {
  padding: 2rem;
}

.page-header {
  margin-bottom: 1.5rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.tabs {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.tab-btn {
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  transition: all 0.15s;
}

.tab-btn:hover { color: #374151; }

.tab-btn.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}
</style>
